<template>
  <div class="col-lg-2">
    <div class="navbar">
    </div>
    <div class="ibox float-e-margins">
      <div class="ibox-content mailbox-content">
        <div class="file-manager">
          <div class="mb30">
            <img
              class="small-logo-submenu"
              v-if="command.realm === 'carizy'"
              src="https://cdn.carizy.com/images/carizy_logo_blanc.svg"
              alt=""
            >
            <img
              class="small-logo-submenu"
              v-if="command.realm === 'renault'"
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/RENAULT_LOGO.png/1280px-RENAULT_LOGO.png"
              alt=""
            >
          </div>
          <h3 class="sub-title">Commande #{{ commandId }}</h3>
          <div class="space-25"></div>
          <ul class="folder-list m-b-md no-paddings">
            <li v-for="(item, index) in items"
                :key="index"
                :class="{'active': isSectionActive(item)}">
              <router-link :to="item.to">
                <span style="display: inline-block; width: 20px;">
                  <i class="fa"
                     :class="item.icon"></i>
                </span>
                {{ item.name }}
              </router-link>
            </li>
            <li v-if="false">
              <a href="documents.html"> <i class="fa fa-files-o"></i> Documents <span class="label label-warning pull-right">2/24</span></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from "graphql-tag";
  export default {
    data: () => ({
      items: [],
      userInfos: {
        userIsExpert: false,
      },
    }),

    props: {
      command: {
          type: Object,
          required: true
      }
    },

    computed: {
      commandId () {
        return this.$route.params.id
      },
      userProfilQuery () {
        return gql`
          query {
          userProfil
            {
            id
            type
            firstname
            lastname
            email
            }
          }`
      },
      isCredit () {
        let mode = [3, 4, 5]
        return mode.includes(this.command.paymentMode)
      }
    },

    created () {
      this.items = []

      let arrayPart1 = [
        {
          name: 'Récapitulatif',
          icon: 'fa-list-alt',
          to: {
            name: 'command-details-recapitulatif'
          }
        },
        {
          name: 'Propriétaire actuel',
          icon: 'fa-user',
          to: {
            name: 'command-details-proprietaire-actuel'
          }
        },
        {
          name: 'Futur propriétaire',
          icon: 'fa-user',
          to: {
            name: 'command-details-futur-proprietaire'
          }
        }
      ]

      let arrayPart2 = []

      if(this.command.delivery){
          arrayPart2 = [
            {
              name: 'Livraison',
              icon: 'fa-flag-checkered',
              to: {
                  name: 'command-details-delivery-light'
              }
            }
          ]
      } else {
          arrayPart2 = [
            {
              name: 'RDV de cession',
              icon: 'fa-calendar',
              to: {
                  name: 'command-details-cession'
              }
            }
          ]
      }

      let arrayPart3 = [
        {
          name: 'Documents',
          icon: 'fa-files-o',
          to: {
            name: 'command-details-documents'
          }
        }
      ]

      let arrayPart4 = []

      if (this.userInfos.userIsExpert === false) {
        if (this.isCredit) {
          arrayPart4 = [
            {
              name: 'Credit',
              icon: 'fa-credit-card-alt',
              to: {
                name: 'command-details-credit'
              }
            },
            {
              name: 'Lemonway',
              icon: 'fa-credit-card-alt',
              to: {
                name: 'command-details-virement-lemonway'
              }
            }
          ]
        } else {
          arrayPart4 = [
            {
              name: 'Lemonway',
              icon: 'fa-credit-card-alt',
              to: {
                name: 'command-details-lemonway'
              }
            }
          ]
        }
      }

      const array = arrayPart1.concat(arrayPart2, arrayPart3, arrayPart4)
      this.items = array
    },

    methods: {
      isSectionActive (item) {
        return item.name === this.$route.meta.name
      },
      getUserProfil () {
        this.getUserProfilIsLoading = true

        this.$apollo.query({
          query: this.userProfilQuery,
          fetchPolicy: 'no-cache'
        }).then(response => {
          this.userInfos.userProfil = response.data.userProfil

          if(this.userInfos.userProfil.type === "Expert"){
            this.userInfos.userIsExpert = true
          }
        }, () => {
          this.showBanner('danger', "Désolé, le userProfil n'est pas disponible.")
        })
      },
    },
    mounted () {
      this.getUserProfil()
    }
  }
</script>
